import _isEqual from 'lodash/isEqual';

import {
  getCategoriesPayloadFromLessonForm,
  getLessonCategoryIdsFromApiLesson,
} from 'helpers/getLessonCategoryIdsFromApiLesson';

export const convertDataToForm = (data: any, readOnly: any) => ({
  id: data.id,
  moduleId: data.moduleId,
  courseId: data.courseId,
  type: data.type,
  title: data.title || '',
  status: data.status,
  questions: data.questions,
  free: data.free,
  categories: getLessonCategoryIdsFromApiLesson(data),
  readOnly,
  statusError: false,
});

export const convertDataToApi = (data: any) => ({
  title: data.title,
  questions: data.questions.map((question: any) => ({
    ...question,
    answers: question.answers.map((answer: any) => ({
      ...answer,
      correct: answer.correct || false,
    })),
  })),
  free: data.free,
  categories: getCategoriesPayloadFromLessonForm(data),
});

export const getChangedProperties = ({
  currentLesson,
  nextLesson,
}: {
  currentLesson: any;
  nextLesson: any;
}) => {
  const properties = [];

  if (currentLesson.title !== nextLesson.title) {
    properties.push('title');
  }

  if (currentLesson.free !== nextLesson.free) {
    properties.push('free');
  }

  if (!_isEqual(currentLesson.questions, nextLesson.questions)) {
    properties.push('questions');
  }

  if (
    !_isEqual(
      [...getLessonCategoryIdsFromApiLesson(currentLesson)].sort(),
      [...getCategoriesPayloadFromLessonForm(nextLesson)].sort(),
    )
  ) {
    properties.push('categories');
  }

  return properties;
};

export const checkCorrectAnswers = (values: any) =>
  !values.questions.some((question: any) =>
    question.answers.every((answer: any) => !answer.correct),
  );

export const checkAnswersValue = (values: any) =>
  values.questions.every((question: any) =>
    question.answers.every((answer: any) => answer.data !== ''),
  );
